import {GeneralResourceSearchTypes} from "./general-resource.types";
import {compareValues} from "../../../utilities/CommonUtilities";
import moment from "moment";

const GENERAL_RESOURCES_SEARCH = {
    lastSearchData: {},
    currentSearchData: {},
}

export const generalResourceSearchData = (state = GENERAL_RESOURCES_SEARCH, action) => {
    switch (action.type) {
        case GeneralResourceSearchTypes.GENERAL_RESOURCE_SEARCH:
            if (action.payload) {
                let payloadData = action.payload;

                let totalDocumentCount = action.payload["@odata.count"];
                let searchFacetsObject = payloadData["@search.facets"]

                let preparedSearchFacets = []
                let preparedObject = {}
                let datePublished = {}

                if (searchFacetsObject) {
                    datePublished = {
                        startDate: moment("1975-03-04T10:57:02.444Z"),
                        endDate: moment().toISOString()
                    }

                    preparedSearchFacets = Object.keys(searchFacetsObject).filter(e => e !== "DatePublished").map(e => {
                        let value = searchFacetsObject[e].filter(element => element.value.length !== 0)
                        return Object.assign({
                            key: e,
                            value: value//.sort(compareValues('count', 'desc'))
                        })
                    })
                }


                preparedObject = Object.assign({}, preparedObject, action.payload, {totalDocumentCount}, {preparedSearchFacets}, {datePublished})
                return {
                    ...state,
                    currentSearchData: preparedObject,
                };
            } else {
                return {
                    ...state
                }
            }

        case GeneralResourceSearchTypes.GENERAL_RESOURCE_LAST_SEARCH:
            if (action.payload) {
                return {
                    ...state,
                    lastSearchData: action.payload,
                };
            } else {
                return {
                    ...state
                }
            }

        default:
            return state;
    }
}
